import { render, staticRenderFns } from "./_ClientDatabaseTable.vue?vue&type=template&id=89255562"
import script from "./_ClientDatabaseTable.vue?vue&type=script&lang=js"
export * from "./_ClientDatabaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports